/* istanbul ignore file */
export default [
  {
    path: '/services/service_versions',
    name: 'serviceVersions',
    component: () => import('../views/ServiceVersions'),
    meta: {
      auth: true,
      anyCan: { service_versions: 'write' }
    }
  }
]
